import React from "react";

export default function ToolbarLotes() {
  return null;
}
